// Maps Auth0 roles to the GA4 `user_role` user property; CommonJS so plain `node` tests can require it.

// First match wins.
const ROLE_PRIORITY = [
  ['arg-group-manager', 'group_manager'],
  ['arg-owner-retailer', 'owner_retailer'],
  ['arg-store-retailer', 'store_retailer']
]

function resolveUserRole(roles) {
  const list = Array.isArray(roles) ? roles : []
  const match = ROLE_PRIORITY.find(([role]) => list.includes(role))
  return match ? match[1] : 'admin_support'
}

module.exports = { resolveUserRole }
